<ng-container *ngIf="!isMobile && !isLoading">
  <div class="navigation-bar" [ngClass]="{ shrinked: isMenuShrinked }">
    <cm-navigation-menu></cm-navigation-menu>
    <div>
      <div class="navigation-bar__bottom-section" [ngClass]="{ shrinked: isMenuShrinked }">
        <ng-container *ngIf="!isMenuShrinked">
          <a
            *ngFor="let item of externalNavItems"
            class="navigation-menu__item navigation-menu__item--blue"
            [ngClass]="{ ' shrinked': isMenuShrinked }"
            target="_blank"
            [href]="item.externalLink"
          >
            <div class="navigation-bar__bottom-content">
              <span *ngIf="!isMenuShrinked">{{ navigationService.navNameTranslation(item.name) }}</span>
            </div>
          </a>
        </ng-container>
        <div *ngIf="isMenuShrinked && isDistributor" class="navigation-bar__item-shrinked">
          <mat-icon data-cy="shrinked-nav-items-additional-links-icon" [matMenuTriggerFor]="additionalinksMenu">
            link
          </mat-icon>
        </div>
        <button
          [disabled]="disableCollapse"
          class="shrink-menu-button"
          [ngClass]="{ ' flipped': !isMenuShrinked }"
          (click)="onShrinkMenu()"
          data-cy="nav-item-expand"
        >
          <mat-icon class="material-icons-filled"> {{ buttonIcon }} </mat-icon>
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isMobile && !isLoading">
  <mat-sidenav-container class="navigation-toolbar">
    <mat-sidenav
      #sidenav
      [mode]="isMobile ? 'over' : 'side'"
      (openedStart)="changeSidenavState(true)"
      (closedStart)="changeSidenavState(false)"
    >
      <nav class="cm-navigation">
        <div *ngIf="navigationService.favoriteMenuItems.length > 0" class="cm-navigation__favorite-section">
          <ng-container *ngFor="let item of navigationService.favoriteMenuItems">
            <cm-menu-navigation-item
              data-cy="favorite-nav-item"
              [navigationItem]="item"
              [sectionChildFavorite]="true"
            ></cm-menu-navigation-item>
          </ng-container>
        </div>
        <div *ngIf="navigationService.menuNavFixedItems.length" class="navigation-menu__top-section">
          <ng-container *ngFor="let item of navigationService.menuNavFixedItems">
            <cm-menu-navigation-item [disableFavorite]="true" [navigationItem]="item"></cm-menu-navigation-item>
          </ng-container>
        </div>
        <div class="cm-navigation__top-section" *ngIf="navigationService.menuNavItems.length > 0">
          <!-- sections -->
          <mat-accordion
            class="navigation-sections"
            *ngIf="navigationService.navigationSections.length && !isShrinked"
            [multi]="true"
          >
            <!-- sections -->
            <mat-expansion-panel
              *ngFor="
                let section of navigationService.navigationSections;
                trackBy: navigationService?.sectionItemIdentifyer
              "
              [hideToggle]="true"
              (opened)="onMenuExpanded(section.name)"
              (closed)="onMenuCollapsed(section.name)"
              #exPanel
            >
              <!-- section header -->
              <mat-expansion-panel-header>
                <div class="navigation-sections__left-icon">
                  <mat-icon
                    class="navigation-sections_icon"
                    [ngClass]="{ ' navigation-sections_icon--active': section.type === this.selectedSection,
                  '  navigation-sections_icon--small-icon': section.type === 'item_and_cribs'
                }"
                    >{{ section.iconClass }}</mat-icon
                  >
                </div>
                <mat-panel-title class="navigation-sections_title"
                  >{{ navigationService.navNameTranslation(section.name) }}</mat-panel-title
                >
                <mat-icon *ngIf="exPanel.expanded" class="navigation-sections_arrow">arrow_drop_up</mat-icon>
                <mat-icon *ngIf="!exPanel.expanded" class="navigation-sections_arrow">arrow_drop_down</mat-icon>
              </mat-expansion-panel-header>
              <!-- section items -->
              <ng-container
                *ngFor="
                  let item of section.items;
                  trackBy: navigationService?.sectionItemIdentifyer
                "
              >
                <cm-menu-navigation-item [navigationItem]="item" [sectionChild]="true"></cm-menu-navigation-item>
              </ng-container>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <div class="cm-navigation__bottom-section">
          <div class="cm-navigation__bottom-section__external-links">
            <a
              *ngFor="let item of externalNavItems"
              data-cy="navigation-item"
              class="navigation-menu__item navigation-menu__item--mobile navigation-menu__item--blue navigation-menu__item--blue--shrinked"
              target="_blank"
              [href]="item.externalLink"
            >
              <div class="cm-navigation__bottom-section--solution mobile-menu-item">
                <span>{{ navigationService.navNameTranslation(item.name) }}</span>
              </div>
            </a>
          </div>
        </div>
      </nav>
    </mat-sidenav>
  </mat-sidenav-container>
</ng-container>

<!-- Additiona links menu -->
<mat-menu #additionalinksMenu="matMenu">
  <button mat-menu-item *ngFor="let item of externalNavItems">
    <a class="navigation-bar__external-link typography__menu-item" [href]="item.externalLink" target="_blank">
      {{ item.name | translate | titlecase }}
    </a>
  </button>
</mat-menu>
